import { router, useLocalSearchParams } from 'expo-router';
import { useCallback, useEffect, useState } from 'react';

/**
 * Consome um parâmetro de foco vindo de deep link/notificação (ex.:
 * `focusChargeId`) uma única vez: guarda o valor em estado local e limpa a URL,
 * para que fechar o modal não o reabra e voltar para a tela não repita a ação.
 *
 * Uso: `const [chargeId, clearFocus] = useFocusParam(FOCUS_PARAM.charge)`.
 */
export function useFocusParam(
  name: string,
): [string | null, () => void] {
  const params = useLocalSearchParams<Record<string, string | string[]>>();
  const raw = params[name];
  const incoming = Array.isArray(raw) ? raw[0] : raw;
  const [value, setValue] = useState<string | null>(incoming ?? null);

  useEffect(() => {
    if (!incoming) return;
    setValue(incoming);
    // Remove o parâmetro da rota atual — o foco já foi capturado.
    router.setParams({ [name]: undefined } as never);
  }, [incoming, name]);

  const clear = useCallback(() => setValue(null), []);

  return [value, clear];
}
